import { render } from "./SolutionSection.vue?vue&type=template&id=2bce8248&scoped=true"
import script from "./SolutionSection.vue?vue&type=script&lang=js"
export * from "./SolutionSection.vue?vue&type=script&lang=js"

import "./SolutionSection.vue?vue&type=style&index=0&id=2bce8248&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bce8248"]])

export default __exports__